import { LngLat } from 'maplibre-gl'

/**
 * @param {string | import('maplibre-gl').LngLatLike | { latitude: number, longitude: number }} coordinates
 * @returns {LngLat}
 */
export function parseCoordinates (coordinates) {
  try {
    if (typeof coordinates === 'string') {
      const [lng, lat] = coordinates.split(',').map(Number)
      return new LngLat(lng, lat)
    }

    if (typeof coordinates === 'object' && 'longitude' in coordinates) {
      return new LngLat(coordinates.longitude, coordinates.latitude)
    }

    return LngLat.convert(coordinates)
  } catch (err) {
    // Coordinates which fail validation are ignored
    return null
  }
}

/**
 * @param {string | [number, number] | { latitude: number, longitude: number}} coordinates
 * @returns {{ coords: Pick<GeolocationCoordinates, 'latitude' | 'longitude'> }}
 * Returns an object suitable as a duck-typed GeolocationPosition object for use
 * with the MapLibre GeolocateControl.
 */
export function getGeolocationPosition (coordinates) {
  const parsedCoords = parseCoordinates(coordinates)

  if (!parsedCoords) {
    return null
  }

  const { lng, lat } = parsedCoords
  return {
    coords: {
      latitude: lat,
      longitude: lng,
    },
  }
}
